import { request } from '@/api/client'
import type { Permission } from '@shared/permissions'

export interface CurrentUser {
  username: string
  userId: number | null
  displayName: string | null
  branchId: number | null
  vsoftRoleId: number | null
  roleKey: string | null
  permissions: Permission[]
  /** Pages closed for this user (صلاحيات المستخدمين); the sidebar and the router both go by it. */
  hiddenPages?: string[]
  /** Pages given «مسموح» to this user by his group or himself: shown even when the global show/hide table hides them. */
  allowedPages?: string[]
  profile: Record<string, unknown>
  sessionExpiresAt: number
}

export interface UserBranch {
  branchID?: number
  branchId?: number
  branchName?: string
  [key: string]: unknown
}

export const authService = {
  async login(username: string, password: string) {
    return (await request<CurrentUser>('/auth/login', { method: 'POST', body: { username, password } })).data
  },
  async logout() {
    await request('/auth/logout', { method: 'POST', body: {} })
  },
  async me(signal?: AbortSignal) {
    return (await request<CurrentUser>('/auth/me', { signal })).data
  },
  async branches() {
    return (await request<UserBranch[]>('/auth/branches')).data ?? []
  },
  async changeBranch(branchId: number) {
    await request(`/auth/branch/${branchId}`, { method: 'POST', body: {} })
  },
  async changePassword(oldPassword: string, newPassword: string) {
    await request('/auth/change-password', { method: 'POST', body: { oldPassword, newPassword } })
  },
}
